export default "__VITE_ASSET__e2b9a7ae__"